import React, { useState, useRef } from "react";
import UpdateUserForm from "./UpdateUserForm";
import { Container, Header, Image, Segment, Form, Input, Button, Divider, Message, Icon } from "semantic-ui-react";
import AddressSearchModal from "../../../common/components/AddressSearchModal/AddressSearchModal";
import { UPDATE_MEMBER_INFO_SUCCESS_MSG } from "../../../common/constants/commonConstant";

const UpdateUser = ({
  onSubmit,
  error,
  isUpdatedUser,
  onClickCancel,
  // 주소
  myInfo,
  addressInput,
  onChangeAddress,
  onSaveAddress,
  isUpdatingAddress,
  isAddressUpdated,
  addressError
}) => {
  // 주소 검색 모달
  const [addressModalOpen, setAddressModalOpen] = useState(false);
  const addressInputRef = useRef(null);

  return (
    <Container style={{ padding: "6em 0em", maxWidth: 600 }}>
      <Header as="h2" textAlign="center">
        <Image src="/images/logo.PNG" /> 회원정보 수정
      </Header>

      <Segment>
        <Header as="h3">비밀번호 변경</Header>
        <UpdateUserForm onSubmit={onSubmit} errorMsg={error} onClickCancel={onClickCancel} />
        {/* 변경 성공 — 주소 저장과 동일 패턴, 2.5초 뒤 자동으로 사라짐 */}
        {isUpdatedUser ? (
          <Message positive size="small">
            <p>{UPDATE_MEMBER_INFO_SUCCESS_MSG}</p>
          </Message>
        ) : null}
      </Segment>

      <Segment>
        <Header as="h3">주소 (배송지)</Header>
        <p style={{ color: "#666" }}>
          도서 신청 시 '집' 옵션을 선택하면 여기에 등록한 주소로 배송됩니다. 비워두면 '집' 옵션 사용 시 안내 메시지가 표시됩니다.
        </p>
        {myInfo == null ? (
          <p>회원정보를 불러오는 중...</p>
        ) : (
          <Form>
            <Form.Field>
              <label>이름 / 사번 / 아이디</label>
              <Input
                value={`${myInfo.mbrName || ""} / ${myInfo.empNum || ""} / ${myInfo.mbrId || ""}`}
                disabled
              />
            </Form.Field>
            <Form.Field>
              <label>주소</label>
              {/* 주소 검색(팝업)과 직접 입력을 분리해 각각 명확하게 */}
              <div style={{ marginBottom: "0.5em" }}>
                <Button
                  type="button"
                  basic
                  primary
                  onClick={() => setAddressModalOpen(true)}
                >
                  <Icon name="search" />
                  주소 검색
                </Button>
                <span style={{ marginLeft: "0.5em", fontSize: "0.9em", color: "#999" }}>
                  또는 아래 칸에 직접 입력하세요
                </span>
              </div>
              <Input
                ref={addressInputRef}
                placeholder="주소를 직접 입력 (주소 검색 후에는 상세주소를 이어서 입력)"
                value={addressInput}
                onChange={e => onChangeAddress(e.target.value)}
              />
            </Form.Field>

            {isAddressUpdated ? (
              <Message positive size="small">
                <p>주소가 저장되었습니다.</p>
              </Message>
            ) : null}
            {addressError ? (
              <Message negative size="small">
                <p>{addressError.retMsg || "주소 저장에 실패했습니다."}</p>
              </Message>
            ) : null}

            <Divider hidden />
            <div style={{ textAlign: "right" }}>
              <Button
                primary
                type="button"
                disabled={isUpdatingAddress}
                loading={isUpdatingAddress}
                onClick={onSaveAddress}
              >
                주소 저장
              </Button>
            </div>
          </Form>
        )}
      </Segment>

      {/* 주소 검색 — 선택 후 상세주소 이어서 입력하도록 포커스 */}
      <AddressSearchModal
        open={addressModalOpen}
        onClose={() => setAddressModalOpen(false)}
        onSelect={addr => {
          onChangeAddress(addr + " ");
          // 모달 닫힘 리렌더 후 포커스
          setTimeout(() => {
            if (addressInputRef.current) addressInputRef.current.focus();
          }, 0);
        }}
      />
    </Container>
  );
};

export default UpdateUser;
